import { c as _c } from "react/compiler-runtime";
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
export interface BackButtonProps {
  link: string;
  label: string;
}
export const BackButton: React.FC<BackButtonProps> = t0 => {
  const $ = _c(5);
  const {
    link,
    label
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      textDecoration: "none"
    };
    t2 = <ArkIcon iconName="chevron-left" size="1rem" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label || $[3] !== link) {
    t3 = <a href={link} className="flex gap-snug-xl items-center label-md label-neutral-moderate pb-snug-xl" style={t1}>{t2}{label}</a>;
    $[2] = label;
    $[3] = link;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};